// Dashboard.tsx
import React, { useEffect } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import Tasks from "../tasks/Tasks";
import { useNavigate } from "react-router-dom";

const Dashboard: React.FC = () => {
  const { currentRoles } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentRoles) {
      currentRoles.map((role) => {
        if (role.name === 'OWNER') { 
          navigate('/dashboard/owner')
        }
      })
    }
  }, [currentRoles]);

  return (
    <div className="">
      <div className=""></div>
        <div className="">
          <div className="">
            <Tasks />
          </div>
        </div>
    </div>
  );
};

export default Dashboard;